import { render, staticRenderFns } from "./PurScL_List.vue?vue&type=template&id=0518843b"
import script from "./PurScL_List.vue?vue&type=script&lang=js"
export * from "./PurScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports